import { Box, Button, Center, Flex, Heading, Image, SimpleGrid, Stack, Text, useBreakpointValue } from '@chakra-ui/react';


const Feature = ({ title, text, icon }) => {
    return (
        <Stack >
            <Center >
                <Image boxSize='132px' src={icon} alt='Dan Abramov' />
            </Center>
            <Center >
                <Text textAlign="center" color="#1C3E64" fontSize="30px" fontWeight={300}>{title}</Text>
            </Center>
        </Stack>
    );
};

export default function BenifitsOfInvesting() {
    return (
        <Stack align="center" px={{ base: "14px", sm: "10vw" }}>
            <Box maxW="1140px" mb="100px" p={4} >
                <Stack direction={{ base: 'column', md: 'row' }} fontWeight="300" color="#1C3E64">
                    <Flex p={8} flex={1} align={'center'} justify={'center'}>
                        <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                            <Text
                                fontSize="41px"
                                fontWeight="300"
                                pb="8px"
                                borderBottom="1px solid rgba(28, 62, 100, 0.50)"
                            >
                                Benefits of Investing with Real Estate
                            </Text>
                            <br />{' '}
                        </Heading>
                    </Flex>
                </Stack>
                <Center>
                    <SimpleGrid columns={{ base: 2, md: 4 }} spacing={100}>

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/247liquidity.png"}
                            title={'24/7 Liquidity'}
                        />


                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/Acessible.png"}
                            title={'Accessible'}
                        />

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/Global.png"}
                            title={'Global'}
                        />

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/smart_contracts.png"}
                            title={'Start Investing'}
                        />

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/transparency.png"}
                            title={'Accessible'}
                        />

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/fasthasslefree-1.png"}
                            title={'Fast & Hassle-Free'}
                        />

                        <Feature
                            icon={"https://redswan.io/wp-content/uploads/2023/03/secure.png"}
                            title={'Secure'}
                        />

                    </SimpleGrid>
                </Center>
            </Box>
        </Stack>
    );
}